import { render, staticRenderFns } from "./List.vue?vue&type=template&id=bcd11c94&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=bcd11c94&prod&scoped=true&lang=css"
import style1 from "./List.vue?vue&type=style&index=1&id=bcd11c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd11c94",
  null
  
)

export default component.exports